import { safeIntParse } from 'utils/helpers/safeParsing';

export const toNullableObjectId = (value: unknown): number | null => {
    const id = safeIntParse(value);
    return id > 0 ? id : null;
};

export const itemLineKey = (productId: number, objectId?: number | null): string =>
    `${productId}:${toNullableObjectId(objectId) || 0}`;
